import axios from "axios";
import state from "../store";

let baseUrl = state.getters.mainAppURL + "customers/";
const getAllCustomerAddresses = (id) => axios.post( state.getters.mainAppURL + "customers/get_all_customer_addresses", id);
const toggleCustomerStatus = (params) => axios.put( state.getters.mainAppURL + "customers/toggle_customer_status", params);
const getBaykedCustomerAddresses = (customer_id) => axios.get(state.getters.mainAppURL + "customers/get_bayked_customer_addresses/" + customer_id);
const deleteBaykedCustomerAddress = (address_id) => axios.delete(state.getters.mainAppURL + "customers/delete_bayked_customer_address/" + address_id);
const getBaykedCustomerDetails = (customer_id) => axios.get(state.getters.mainAppURL + "customers/get_bayked_customer_details/" + customer_id);
const getBaykedCustomerCoupons =  (customer_id) => axios.get(baseUrl + "get_bayked_customer_coupon/" + customer_id);
const updateBaykedCustomerDetails = (customer_details) => axios.post(state.getters.mainAppURL + "customers/update_bayked_customer_details", customer_details)
const deleteBaykedCustomer = (customer_id) => axios.delete(state.getters.mainAppURL + "customers/delete_bayked_customer/" + customer_id);
const revokeCustomerAccDeletionRequest = (customer_id) => axios.put(baseUrl + "revoke_account_deletion_request/" + customer_id);
const getAllCustomersUsingWildCard = (params) => axios.post( state.getters.mainAppURL + "customers/get_all_customers_using_wildcard", params);
const getAllUsersUsingWildCard = (params) => axios.post( state.getters.mainAppURL + "customers/get_all_users_using_wildcard", params);

export {
    getAllCustomerAddresses,
    toggleCustomerStatus,
    getBaykedCustomerAddresses,
    deleteBaykedCustomerAddress,
    getBaykedCustomerDetails,
    updateBaykedCustomerDetails,
    deleteBaykedCustomer,
    revokeCustomerAccDeletionRequest,
    getAllCustomersUsingWildCard,
    getAllUsersUsingWildCard,
    getBaykedCustomerCoupons
}